import React from "react";
import "./ArticleRow.css";
import serverUrl from "../../constants/serverUrl";

const ArticleRow = ({ image, title, body, linkColor, bgColor, pColor, titleColor, isHTMLBody, id, link }) => {
  return (
<div className="card border-0 rounded" style={{ color: titleColor, backgroundColor: bgColor }}>
  { image && <img src={serverUrl + image} alt={title} className="card-img-top myimg" /> }
  <div className="card-body p-4" style={{ color: titleColor, backgroundColor: bgColor }}>
    <h1 className="card-title">{title}</h1>
    <div className="card-text small text-truncate-multiline">
      {body && !isHTMLBody && (<p style={{ color: pColor }} className="article-row-p">
        {body}
      </p>)}
      {body && isHTMLBody && (
        <div
          className="article-row-html"
          dangerouslySetInnerHTML={{ __html: body }}
          style={{ color: pColor }}
        />
      )}
    </div>
    
    <a href={ link ? link :`/news-post/${id}`} className="btn btn-link text-primary p-0" style={{ color: linkColor }}>
      <span style={{color: linkColor }}>Find out more</span>
    </a>
  </div>
</div>
  );
};

export default ArticleRow;


// WEBPACK FOOTER //
// src/components/ArticleRow/ArticleRow.js